import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { DashboardFeatureConfig } from '../../../types/features/DashboardFeatureConfig';
import { dashboard as base } from './base';
import { dashboard as AT } from './AT';
import { dashboard as CZ } from './CZ';
import { dashboard as HR } from './HR';
import { dashboard as HU } from './HU';
import { dashboard as RO } from './RO';
import { dashboard as RS } from './RS';
import { dashboard as SK } from './SK';

export const dashboardConfig: InsuranceIndex<DashboardFeatureConfig> = {
    base,
    AT,
    CZ,
    HR,
    HU,
    RO,
    RS,
    SK,
};
